module.exports = __webpack_public_path__ + "img/quad-heating-md.a735e41f.svg";